import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { SearchArea, PageArea} from './styled';
import useApi, {IMAGE} from '../../helpers/SalatoAPI'
import {Loading} from '../../components/Loading';
import { isLogged } from '../../helpers/AuthHandler';
import { PageContainer } from '../../components/MainComponents';
import AdItem from '../../components/partials/AdItem';
import SmoothImage from '../../components/SmoothImage';
import { CEPMask } from '../../components/Mask';
import { id } from 'date-fns/locale';

let timer;
let List = [];
const BASE = IMAGE;
const mockProductSections = [
    {
        title: 'Linha Lanche',
        description: 'Produtos maiores para lanches e vitrines.',
        products: [
            {
                id: 1,
                name: 'Coxinha de Frango',
                image: require('../../assets/images/coxinhadefrango.webp')
            },
            {
                id: 2,
                name: 'Coxinha de Frango com Catupiry',
                image: require('../../assets/images/coxinhacatupiry.webp')
            },
            {
                id: 3,
                name: 'Coxinha de Carne Seca com Catupiry',
                image: require('../../assets/images/coxinhacarnesec.webp')
            },
            {
                id: 4,
                name: 'Coxinha de Costela',
                image: require('../../assets/images/coxinhacostela.webp')
            },
            {
                id: 5,
                name: 'Kibe com Catupiry',
                image: require('../../assets/images/kibecatupiry.webp')
            },
            {
                id: 6,
                name: 'Enroladinho de Queijo com Presunto',
                image: require('../../assets/images/enroladoqp.webp')
            },
            {
                id: 7,
                name: 'Salsicha Lanche',
                image: require('../../assets/images/salsichalanche.webp')
            },
            {
                id: 8,
                name: 'Bolinho de Aipim com Carne Seca',
                image: require('../../assets/images/aipimcarneseca.webp')
            },
            {
                id: 9,
                name: 'Bolinho de Aipim com Carne Moída',
                image: require('../../assets/images/aipimlanche.webp')
            }
        ]
    },
    {
        title: 'Linha Mini',
        description: 'Salgados ideais para festas e coffee breaks.',
        products: [
            {
                id: 7,
                name: 'Bolinho de Queijo',
                image: require('../../assets/images/bolinhadequeijo.webp')
            },
            {
                id: 8,
                name: 'Bolinho de Aipim com Carne Seca',
                image: require('../../assets/images/aipimcarneseca.webp')
            },
            {
                id: 9,
                name: 'Salsicha Empanada',
                image: require('../../assets/images/salsichaemp.webp')
            },
            {
                id: 10,
                name: 'Kibe Tradicional e Com Requeijão',
                image: require('../../assets/images/kibecat.webp')
            },
            {
                id: 11,
                name: 'Bolinha de Calabresa',
                image: require('../../assets/images/bolinhacalabresa.webp')
            },
            {
                id: 12,
                name: 'Bolinho de Aipim com Carne Moida',
                image: require('../../assets/images/bolinhoaipimmoidamini.webp')
            },
            {
                id: 13,
                name: 'Coxinha de Frango',
                image: require('../../assets/images/coxinhamini.webp')
            },
            {
                id: 14,
                name: 'Travesseiro de Queijo com Presunto',
                image: require('../../assets/images/travesseiroqp.webp')
            },
            {
                id: 15,
                name: 'Kibe Tradicional',
                image: require('../../assets/images/kibetradicionalmin.webp')
            },
            {
                id: 16,
                name: 'Travesseiro de Carne Moída',
                image: require('../../assets/images/travesseirocarne.webp')
            }

        ]
    },
    {
        title: 'Linha Bolinhos de Bacalhau',
        description: 'Uma opção clássica e saborosa para ampliar seu catálogo.',
        products: [
            {
                id: 17,
                name: 'Bolinho de Bacalhau 45% 20G',
                image: require('../../assets/images/bolinhobacalhau45.webp')
            },
            {
                id: 18,
                name: 'Bolinho de Bacalhau 75% 20G',
                image: require('../../assets/images/bacahau2075.webp')
            },
            {
                id: 19,
                name: 'Bolinho de Bacalhau 45% 80G',
                image: require('../../assets/images/bacalhau8045.webp')
            },
             {
                id: 20,
                name: 'Bolinho de Bacalhau 45% 15G',
                image: require('../../assets/images/bacalhau1545.webp')
            },
             {
                id: 21,
                name: 'Bolinho de Bacalhau 45% 15G',
                image: require('../../assets/images/bacalhau1545.webp')
            }
        ]
    },
    {
        title: 'Linha Assados',
        description: 'Opções assadas para diversificar o seu catálogo.',
        products: [
            {
                id: 11,
                name: 'Pastel de Forno de Camarão',
                image: require('../../assets/images/pastelcamarao.webp')
            },
            {
                id: 12,
                name: 'Pastel de Forno de Frango',
                image: require('../../assets/images/pastelfrango.webp')
            },
            {
                id: 13,
                name: 'Pastel de Forno de Queijo',
                image: require('../../assets/images/pastelqueijo.webp')
            },
            {
                id: 14,
                name: 'Hamburguer de Forno',
                image: require('../../assets/images/hamburguerforno.webp')
            },
            {
                id: 15,
                name: 'Joelho de Queijo com Presunto',
                image: require('../../assets/images/joelhoqp.webp')
            },
            {
                id: 16,
                name: 'Joelho de Frango com Catupiry',
                image: require('../../assets/images/joelhofrangocatupiry.webp')
            },
            {
                id: 17,
                name: 'Joelho de Calabresa com Queijo',
                image: require('../../assets/images/joelhocalabresa.webp')
            },
            {
                id: 18,
                name: 'Cachorro Quente',
                image: require('../../assets/images/cachorroquente.webp')
            }
        ]
    }
];

const Page =  (props) => {
    const api = useApi();
    const useQueryString = () => {
        return new URLSearchParams( useLocation().search );
    }
    const query = useQueryString();
    
    const [pIdProduto, setpIdProduto] = useState(query.get('IdProduto') !== null ? query.get('IdProduto') : '');
    const [addInfo, setAddInfo] = useState([]);
    const [addGrupo, setAddGRupo] = useState([]);
    const [vlSubTotal, setVlSubTotal] = useState(0);
    const [vlDesconto, setVlDesconto] = useState(0);
    const [VlTotalProduto, setVlTotalProduto] = useState(0);
    const [NmProduto, setNmProduto] = useState('');
    const [ProdutoTotal, setProdutoTotal] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [resultOpacity, setresultOpacity] = useState(1);
    const [StLoading, setStLoading] = useState(false);
    const [StLoadingCEP, setStLoadingCEP] = useState(false);
    const [idGrupoProduto, setIdGrupoProduto] = useState('36');
    const [modalIsOpen, setmodalIsOpen] = useState(false);
    const [idProduto, setIdProduto] = useState(0);
    const [srcLinck, setsrcLinck] = useState('');
    const [DsNmProduto, setDsNmProduto] = useState('');
    const [Preco, setPreco] = useState(0);
    const [DsProdutoSite, setDsProdutoSite] = useState('');
    const [qtProduto, setQtProduto] = useState(1);
    const [logged] = useState(isLogged);
    const [DsCEP, setDsCEP] = useState('');
    const [DsEndereco, setDsEndereco] = useState([]);
    const [selectedSection, setSelectedSection] = useState(mockProductSections[0].title);

    const activeSection = mockProductSections.find((section) => section.title === selectedSection) || mockProductSections[0];
 
    const getGrupoProduto = async () => {
        const json = await api.getGrupoProduto(1, 0);
        setAddGRupo(json.GrupoProduto);
        
    }

    const getInfoProduto = async () => {
        
        let Limit = 8;
        let offset = (currentPage-1) * Limit + 1;
        const json = await api.getProdutoBanner(
            NmProduto,
            1,
            Limit,
            0,
            offset,
            idGrupoProduto
        );
        setAddInfo(json.Produtos);
        setProdutoTotal(json.CountProdutos);
        setresultOpacity(1);
        setStLoading(false);
        if (pIdProduto){
            getProduto();
        }
    }

    const carregaCEP = async (v) => {
        const json = await api.getEndereco(v);
        setDsEndereco(json);   
        setStLoadingCEP(false);
        Cookies.set('CEP', v);
    }

    const changeCEP = () =>{
        if (timer){
            clearTimeout(timer);
        }   
        setStLoadingCEP(true); 
        timer = setTimeout(()=>{
            if(DsCEP.length >= 10 && DsCEP.length <= 11){
                carregaCEP(DsCEP);
            }else{
                setStLoadingCEP(false); 
                setDsEndereco([]);
                Cookies.remove('CEP');
            }
        },2000);
    }

    const setCEP = (v) => {
        setDsCEP(CEPMask(v));
    }

    const getCarCompra = async () => {
        let jwt = Cookies.get('token');
        const json = await api.getCarCompra(
            jwt
        );
        List = json.CarrinhoDeCompra;
        UpdateCart();        
    }

    const deleteCarCompra = async (tIdProduto) => {
        let jwt = Cookies.get('token');

        const json = await api.deleteCarCompra(
            jwt,
            tIdProduto
        )
        return json;
    }

    const InsertCarCompra = async () => {
        let jwt = Cookies.get('token');
        const json = await api.insertCarCompra(
            jwt,
            idProduto,  
            qtProduto
        );
        return json;
    }

    const UpdateCarCompra = async (tIdProduto, tQtProduto) => {
        let jwt = Cookies.get('token');
        const json = await api.updateCarCompra(
            jwt,
            tIdProduto,  
            tQtProduto
        );
        return json;
    }

    const getProduto = async () => {
        const json = await api.getProdutoBanner(
            NmProduto,
            1,
            1,
            0,
            1,
            0,
            pIdProduto
        );
        OpemModal(json.Produtos[0]);
    }

    const OpemModal = (i) => {
        setsrcLinck(i.LinckImage);
        setDsNmProduto(i.NmProduto);
        setPreco(parseFloat(i.VlPreco).toFixed(2));
        setIdProduto(i.IdProduto);
        setDsProdutoSite(i.DsProdutoSite);
        setmodalIsOpen(!modalIsOpen);
        
        setTimeout(()=>{
            if (!modalIsOpen){
                document.querySelector('.WindowBody').style.opacity = 1;
            }
        },200)
    }
    
    const closeModal =  () =>{
        
        if (modalIsOpen){
            document.querySelector('.WindowBody').style.opacity = 0;
        }
        
        setTimeout(()=>{
            setmodalIsOpen(!modalIsOpen);
        },200);
        setpIdProduto('');
    }

    const IncQuantidade = () => {
        let v = qtProduto + 1;
        setQtProduto(v);
    }

    const DecQuantidade = () => {
        let v = qtProduto - 1;
        if (v >= 1){
            setQtProduto(v);
        }
    }

    const IncCartQT = (i,k) => {
        let arr = [];
        i.QtPedida ++;
        arr = List;
        arr[k].QtPedida = i.QtPedida;
        arr[k].VlTotal = i.QtPedida * i.VlUnitario;
        List = arr;
        UpdateCart();
        UpdateCarCompra(arr[k].IdProduto, parseFloat(arr[k].QtPedida));
    }

    const DecCartQT = (i,k) => {
        if (i.QtPedida > 1){
            let arr = [];
            i.QtPedida --;
            arr = List;
            arr[k].QtPedida = i.QtPedida;
            arr[k].VlTotal = i.QtPedida * i.VlUnitario;

            UpdateCart();
            UpdateCarCompra(arr[k].IdProduto, parseFloat(arr[k].QtPedida));
        }
    }

    const SomaValoresTotais = () => {
        let promise = new Promise((resolve, reject) =>{
            let v = 0;
            for (let i in List){
                v = v + parseFloat(List[i].VlTotal);
            }
            resolve(v);
        })
        return promise;
    }

    const SomaItensTotais = () => {
        let promise = new Promise((resolve, reject) =>{
            let q = 0;
            for (let i in List){
                q = q + parseFloat(List[i].QtPedida);
            }
            resolve(q);
        })
        return promise;
    }
    
    const UpdateCart = () =>{
    
        SomaItensTotais()
        .then((r) => {
            props.setQt(r)
            
        });

        SomaValoresTotais()
        .then((r) => {
            let taxa = 4
            setVlDesconto(taxa);
            setVlSubTotal(r);
            setVlTotalProduto(r+taxa);
        })   
    }

    const getPesquisa = (e) => {
        if (e){
            e.preventDefault();   
        }
        setresultOpacity(0.3);
        if (currentPage !== 1){
            setCurrentPage(1);
        }else {
            getInfoProduto();
        }
        
    };

    const removeItem = (i,k) => {
        List.splice(k,1);
        deleteCarCompra(i.IdProduto);
        UpdateCart();
        if (List.length == 0){
            props.setStCart(false);
        }
    }


    const getItem = () => {
        let VlPrecoFinal  = 0;
        VlPrecoFinal = qtProduto * Preco;

        let key = List.findIndex((item) =>item.IdProduto == idProduto);

        if (key > -1){
            List[key].QtPedida = parseFloat(List[key].QtPedida) + parseFloat(qtProduto);
            List[key].VlTotal = List[key].QtPedida * Preco;
            UpdateCarCompra(List[key].IdProduto, parseFloat(List[key].QtPedida));
        }else{
            InsertCarCompra();
            List.push({
                "IdProduto":idProduto,  
                "NmProduto":DsNmProduto, 
                "LinckImage":srcLinck, 
                "QtPedida":qtProduto, 
                "VlUnitario":Preco, 
                "VlTotal":VlPrecoFinal});
        }
        props.setStCart(true);
        UpdateCart();
        closeModal();
    }

    useEffect(()=>{
        if (!modalIsOpen){
            setQtProduto(1);
        }
    },[modalIsOpen])

    useEffect(()=>{
        if(addInfo.length > 0) {
            setPageCount( Math.ceil( ProdutoTotal / addInfo.length ) );
        } else {
            setPageCount( 0 );
        }
        
    },[ProdutoTotal]);

    useEffect(() =>{
        setStLoading(true);
        setresultOpacity(0.3);
        setTimeout(()=>{
            getInfoProduto();
        },1000)

    },[currentPage])

    useEffect(() =>{
        getInfoProduto();
        getGrupoProduto();
        UpdateCart();
        if(Cookies.get('CEP')){
            setDsCEP(Cookies.get('CEP'));
        }

    },[])

    useEffect(() => {
        changeCEP(DsCEP);
    },[DsCEP])

    useEffect(() => {
        if (logged){
            getCarCompra();
        }
    },[logged])

    useEffect(() => {
        if (currentPage !== 1){
            setCurrentPage(1);
        }else {
            getInfoProduto();
        }
       
    },[idGrupoProduto])
    
    let pagination = [];
    for(let i=1;i<=pageCount;i++) {
        pagination.push(i); 
    }
    return(
        <> 
            <PageContainer>
                <PageArea>
                    <div className="AreaList">
                        <div className="productsTitle">
                            <span className="sectionTag">Catálogo</span>
                            <h2>Nossos produtos</h2>
                            <p>Escolha a linha e conheça os salgados que produzimos.</p>
                        </div>
                        <div className="mockSections">
                            <div className="sectionTabs">
                                {mockProductSections.map((section) => (
                                    <button
                                        type="button"
                                        key={section.title}
                                        className={section.title === activeSection.title ? 'tabButton active' : 'tabButton'}
                                        onClick={() => setSelectedSection(section.title)}
                                    >
                                        {section.title}
                                    </button>
                                ))}
                            </div>

                            <div className="sectionBlock">
                                <div className="sectionHeader">
                                    <h3>{activeSection.title}</h3>
                                    <span>{activeSection.description}</span>
                                </div>

                                <div className="sectionGrid">
                                    {activeSection.products.map((product) => (
                                        <div className="sectionCard" key={`${activeSection.title}-${product.id}`}>
                                            <div className="sectionCardImage">
                                                <SmoothImage src={product.image} alt={product.name} width="640" height="480" />
                                            </div>
                                            <div className="sectionCardInfo">
                                                <strong>{product.name}</strong>
                                            </div>
                                        </div>
                                    ))}

                                    {activeSection.products.length === 0 && (
                                        <div className="sectionEmpty">
                                            Adicione produtos nesta seção.
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </PageArea>
            </PageContainer>
        </>
    )
}

const mapStateToProps = (state) =>{
    return{
        nome:state.user.nome,
        qt:state.user.qt,
        StCart:state.user.StCart
    }
}

const mapDispatchToProps = (dispatch) => {
    return{
        setNome:(nome)=>dispatch({type:'SET_NOME', payload:{nome}}),
        setQt:(qt)=>dispatch({type:'SET_QT', payload:{qt}}),
        setStCart:(StCart)=>dispatch({type:'SET_CART', payload:{StCart}})

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Page)